var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"betrieb"}},[_c('section',{attrs:{"id":"stage"}},[_c('v-img',{attrs:{"src":require("../assets/stage/stage_drachenkopf.jpg"),"lazy-src":require("../assets/stage/80/stage_drachenkopf.jpg"),"height":this.$vuetify.breakpoint.height / 2.4}})],1),_c('Intro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }